module.exports = __webpack_public_path__ + "img/043-energy-saving-light.c7802995.svg";